import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, Eye } from "lucide-react";
import { HelpArticle } from "@/types/help";

interface PopularArticlesWidgetProps {
  articles: HelpArticle[];
  onArticleClick: (articleId: string) => void;
}

const PopularArticlesWidget = ({ articles, onArticleClick }: PopularArticlesWidgetProps) => {
  // Get top 5 articles by view count
  const popularArticles = [...articles]
    .sort((a, b) => b.view_count - a.view_count)
    .slice(0, 5);

  if (popularArticles.length === 0) return null;

  return (
    <Card className="bg-card border-border">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <TrendingUp className="h-4 w-4 text-primary" />
          Popular Articles
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {popularArticles.map((article, index) => (
          <Button
            key={article.id}
            variant="ghost"
            className="w-full justify-start text-left h-auto py-3 px-3"
            onClick={() => onArticleClick(article.id)}
          >
            <div className="flex items-start gap-3 w-full">
              <div className="flex items-center justify-center h-6 w-6 rounded-full bg-primary/10 text-primary font-semibold text-xs shrink-0 mt-0.5">
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground line-clamp-2 mb-1">
                  {article.question}
                </p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Badge variant="outline" className="text-xs py-0 h-5">
                    {article.category}
                  </Badge>
                  <span className="flex items-center gap-1">
                    <Eye className="h-3 w-3" />
                    {article.view_count}
                  </span>
                </div>
              </div>
            </div>
          </Button>
        ))}
      </CardContent>
    </Card>
  );
};

export default PopularArticlesWidget;
